import React, { useEffect, useState } from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { Row } from 'reactstrap';

import HitCard from 'Components/Cards/HitCard';
import TopSellersCard from 'Components/TopSellers/TopSellersCard';
import Meta from 'Components/Utility/SEO/Meta';
import { fetchMostWanted } from 'Redux/ducks/algolia-calls';
import NotFound from 'Components/NotFound/NotFound';


const messages = defineMessages({
  title: {
    id: 'mostWanted.title',
    defaultMessage: 'Most Wanted | Most wanted PC and Steam Games | Fanatical',
  },
  meta_description: {
    id: 'mostWanted.meta_description',
    defaultMessage: 'Choose from the most wished for games by our gaming community',
  },
});

function MostWanted() {
  const [results, setResults] = useState({ hits: [], noHitsFound: false });
  const { formatMessage } = useIntl();

  useEffect(() => {
    const fetchHits = async () => {
      const data = await fetchMostWanted(25);
      setResults({
        hits: data,
        noHitsFound: !Array.isArray(data) || data?.length === 0,
      });
    };

    fetchHits().catch(() => setResults({ hits: [], noHitsFound: true }));
  },
  []);

  const { hits, noHitsFound } = results;

  if (noHitsFound) return <NotFound />;
  if (!Array.isArray(hits) || hits?.length === 0) return false;

  return (
    <main className="container">
      <Meta
        title={formatMessage(messages.title)}
        url="most-wanted"
        description={formatMessage(messages.meta_description)}
        hits={hits}
        pageType="CollectionPage"
      />
      <div className="mb-5 pt-5 top-sellers">
        <h1 className="pb-3">
          <FormattedMessage id="mostWanted.header" defaultMessage="Most Wanted" />
        </h1>
        <div className="d-block d-sm-none d-md-block d-lg-none">
          <Row>
            {hits.map(hit =>
              <HitCard
                key={hit.objectID}
                hit={hit}
                xsSize={6}
                mdSize={4}
              />,
            )}
          </Row>
        </div>
        <div className="d-none d-lg-block">
          {hits.map((hit, index) =>
            <TopSellersCard
              key={hit.objectID}
              hit={hit}
              index={index}
            />,
          )}
        </div>
      </div>
    </main>
  );
}

export default MostWanted;
